// extracted by mini-css-extract-plugin
module.exports = {"gameProjectIcon":"GameProjectIcon_gameProjectIcon_21Svc","icon":"GameProjectIcon_icon_127cP","count":"GameProjectIcon_count_31uJo"};